export default {"src":"/_next/static/media/technical_issues.8267abb9.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};